"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighchartsOptionsProviderCommon = void 0;
const getSymbol = (color) => "<span style='color:" + color + "'>\u25CF</span>";
const TooltipFormatter = {
    getSymbol: getSymbol,
    shared: {
        tableOpen: () => "<table>",
        tableClose: () => "</table>",
        pointRow: (symbolColor, label = "", value = "", postfix = "") => {
            return `<tr><td style="padding-right: 5px">${getSymbol(symbolColor)} ${label}:</td><td style="text-align: right;padding-right: 5px;"><b>${value}</b>${postfix}</td></tr>`;
        }
    }
};
exports.HighchartsOptionsProviderCommon = {
    TooltipFormatter: TooltipFormatter
};
